import React from 'react';
import { theme } from '@fiverr-private/theme';
import { brandPageTheme } from '../../shared/constants';
import { imgSrcSet, imgSrcSetFull, imgSrcSetRetina } from '../../shared/image/image';
import { lazyImageWithSrcset } from './styles.ve.css';

interface LazyImageWithSrcsetProps {
  src: string;
  alt: string;
  imgWidth: Partial<Record<keyof typeof resolutions, number>>;
}

const resolutions = {
  default: '(min-width: 0px)',
  sm: theme.breakpoints.sm,
  md: theme.breakpoints.md,
  lg: theme.breakpoints.lg,
  xl: theme.breakpoints.xl,
  xxl: brandPageTheme.breakpoints.xxl,
  xxxl: brandPageTheme.breakpoints.xxxl,
};

const DEFAULT_SIZE = 212;

const LazyImageWithSrcset: React.FC<LazyImageWithSrcsetProps> = ({ src, alt, imgWidth }) => (
  <picture>
    {Object.keys(imgWidth).map((resolution, index) =>
      index === 0 ? null : (
        <source
          key={resolution}
          media={resolutions[resolution]}
          srcSet={imgSrcSetFull({ width: imgWidth[resolution], img: src, retinaImg: src })}
        />
      )
    )}
    <img
      alt={alt}
      src={imgSrcSet({ width: imgWidth?.[Object.keys(imgWidth)[0]] || DEFAULT_SIZE, img: src })}
      srcSet={imgSrcSetRetina({ width: imgWidth?.[Object.keys(imgWidth)[0]] || DEFAULT_SIZE, img: src })}
      width="100%"
      height="100%"
      className={lazyImageWithSrcset}
      loading="lazy"
    />
  </picture>
);

export default LazyImageWithSrcset;
